import WrapperBox from 'components/WrapperBox';
import ChaseMenuItem from '../ChaseMenuItem';
import { MenuWrapper } from './ChaseMenu.styles';
import { ChaseMenuProps } from './ChaseMenu.types';
import { useState } from 'react';
import useSound from 'use-sound';
import ClickSound from 'assets/sounds/Tap.wav';
import { useTranslation } from 'react-i18next';

const ChaseMenu = ({
  width = '100%',
  height = '4.688rem',
  shadowColor = '#007AD1',
  borderRadius,
  borderColor,
  items,
  setMenu,
  ...rest
}: ChaseMenuProps): JSX.Element => {
  const [playClick] = useSound(ClickSound);
  const [activee, setActive] = useState(0);
  const { t } = useTranslation();

  // handle Active item
  const handleActive = (index: number) => {
    setActive(index);
    setMenu(items[index]?.title.toLowerCase());
  };

  return (
    <WrapperBox
      width={width}
      height={height}
      borderColor={borderColor}
      shadowColor={shadowColor}
      {...rest}
    >
      <MenuWrapper>
        {items?.map((item, index) => (
          <ChaseMenuItem
            key={item.title}
            imageSrc={item.imageSrc}
            title={t(item.title)}
            active={activee === index}
            onClick={() => {
              playClick();
              handleActive(index);
            }}
          />
        ))}
      </MenuWrapper>
    </WrapperBox>
  );
};

export default ChaseMenu;
